import BuildingInsights_132 from '@carbon/icons-react/es/building--insights-1/32';
import React, { FC } from 'react';
import styled from 'styled-components';
import { PartnerCompany } from 'api/partner/types';
import { Avatar } from 'components/atoms/avatar';
import { Page } from 'components/molecules/page';

const {
  Header: { Title },
} = Page;
const PageTitle = styled(Title)`
  gap: var(--spacing-06);
`;

interface Props {
  partner: PartnerCompany;
}
export const PageHeader: FC<Props> = ({ partner }) => {
  return (
    <PageTitle>
      <Avatar
        shape="square"
        size="large"
        // eslint-disable-next-line react/jsx-pascal-case
        icon={<BuildingInsights_132 />}
        src={partner.companyLogoUrl}
      />
      {partner.companyName}
    </PageTitle>
  );
};
